import AbstractModal from 'static/script/utils/abstract-modal';
import Spinner from 'static/script/libs/spin';

// This Component extends AbstractModal
function ModalUI() {

    this._loading = function (evt, opts) {
        this._cancelSpinner();
        if (!this._isActive()) {
            this.trigger('ui:modal:open', { content: '<div class="modal-empty" />' });
        }
        let spinner = new Spinner({
            width: 2,
            length: 4,
            radius: 5,
            lines: 11,
            color: '#404a54'
        });
        if (opts && opts.element) {
            let $el = $(opts.element);
            $el.css('opacity', 0.5);
            $el.wrap('<div />').parent().each(function () {
                spinner.spin(this);
            });
        } else {
            let e = this.$modalContent[0];
            this.$modalHtml.addClass('modal-loading');
            this.timeout = setTimeout(function () {
                spinner.spin(e);
            }, 500);
        }

    };

    this.after('initialize', function () {
        this.on(document, 'ui:modal:open', this.triggerOpen);
        this.on(document, 'ui:modal:close', this.triggerClose);
        this.on(document, 'ui:modal:set-non-dismissible', this.triggerSetNonDismissible);
        this.on(document, 'data:navigation:before-modal-load', this._loading);
    });
}

export default AbstractModal.mixin(ModalUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/modal-ui.js